import props from "./../../../src-utils/propDefiner";

export default {
    ...props("min", { type: Number, default: 1 }, "pm-number-input"),
    ...props("max", { type: Number, default: 10 }, "pm-number-input"),
    ...props("inputDisabled", { type: Boolean, default: undefined }, "pm-number-input"),

};
